import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { LoginService } from './services/login.service';
import { Router, NavigationStart, Event } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  isLoggedIn: boolean;
  logoutTimer: any;
  allowedUrls = ['/Login', '/SSOLogin', '/NewsAndUpdates', '/CustService', '/Register', '/About', '/SetPass', '/TermsOfService'];

  constructor(private loginService: LoginService, private router: Router) {
    let self = this;
    this.setupLogoutTimer();
    router.events.subscribe((evt: Event) => {
      if (evt instanceof NavigationStart) {
        let isLoggedIn = self.loginService.getIsLoggedIn();
        this.isLoggedIn = isLoggedIn;
        let url = evt.url;
        let isAllowed = self.isAllowedUrl(url);
        if (!isAllowed && !isLoggedIn) {
          const urlParams = new URLSearchParams(window.location.search);
          const sToken = urlParams.get('stoken');
          const deviceId = parseInt(urlParams.get('deviceId'));
          if (isNaN(deviceId)){
            self.router.navigate(['/Login']);
          } else {
            self.router.navigate(['/Login'], {queryParams: {stoken: sToken, deviceId: deviceId}});
          }
        }
      }
    });
  }

  ngOnInit() {
    this.loginService.getUserIsLoggedIn().subscribe(login => this.isLoggedIn = login);
  }

  @HostListener('document:click')
  documentClickedEvent() {
    // Reset timer if any click events occurs
    this.setupLogoutTimer();
  }

  setupLogoutTimer() {
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
    }

    // Set logout Timer for 2 hours
    let self = this;
    let logoutTimeout = 7200000;
    this.logoutTimer = setTimeout(function () {
      self.loginService.clearUserContext();
      self.router.navigate(['/Login']);
    }, logoutTimeout);
  }

  isAllowedUrl(url: string) {
    const lowerUrl = url.toLocaleLowerCase();
    for (let i = 0; i < this.allowedUrls.length; i++) {
      let allowedUrl = this.allowedUrls[i].toLocaleLowerCase();
      if (lowerUrl.indexOf(allowedUrl) >= 0) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts